import React from "react";

const DashboardHome = () => {
    return ( 
        <>
            <h2>Dashboard Home</h2>
        </>
     );
}
 
export default DashboardHome;